import { HTMLAttributes } from 'react';

import { Button } from '@web/components/ui/button';

export function ReplySuggestions({
  suggestions,
  onSelectReply,
}: HTMLAttributes<HTMLDivElement> & {
  suggestions: { uuid: string; content: string }[];
  onSelectReply?: (message: { uuid: string; content: string }) => void;
}) {
  return (
    <ul className="flex flex-col gap-1.5 pb-0">
      {suggestions.map((message) => (
        <li key={message.uuid} className="text-gray-700 text-sm">
          <Button
            variant="ghost"
            className="inline-block h-max whitespace-normal text-start p-2 rounded-lg w-full hover:bg-blue-100/50 hover:text-blue-700 border border-transparent hover:border-blue-200"
            onClick={() => {
              onSelectReply?.(message);
            }}
          >
            <p className="text-xs">{message.content}</p>
          </Button>
        </li>
      ))}
    </ul>
  );
}
